export const catalog = {
  catalogSearchInputPlaceholderTitle: 'Поиск',
  catalogHeaderTitle: 'Детали',
  catalogDetailsCurtainCopyOptionTitle: 'Скопировать ссылку',
  catalogDetailsLinkCopiedAlertText: 'Ссылка скопирована!',
  catalogDetailsCurtainFlagOptionTitle: 'Пожаловаться',
  catalogDetailsFlagCurtainTitle: 'Пожаловаться',
  catalogReportedCurtainContent: 'Жалоба отправлена',
  catalogWantBuy: 'Хочу купить {item} из {app}',
  catalogInterestedIn: '{link}'
}
